<script>
	import SvelteFa from '$lib/components/SvelteFa.svelte';
	import {
		faCircleExclamation,
		faCircleCheck,
		faCircleInfo
	} from '@fortawesome/free-solid-svg-icons';

	export let elemId;
	export let message;
	export let type;
	export let useHtml = false;
	export let pos = 'toast-center toast-middle';
	export let functions = [];
</script>

<div
	id={elemId}
	class={`toast ${pos} alert ${
		type === 'success'
			? 'alert-success'
			: type === 'warning'
				? 'alert-warning'
				: type === 'info'
					? 'alert-info'
					: 'alert-error'
	} w-full max-w-xs hidden z-20 p-1`}
>
	<div class="block">
		<div class="inline-flex">
			<div class="inline-flex flex-shrink-0 justify-center items-center w-8 h-8">
				{#if type === 'success'}
					<SvelteFa icon={faCircleCheck} size="1.5x" />
					<span class="sr-only">Check icon</span>
				{/if}
				{#if type === 'info'}
					<SvelteFa icon={faCircleInfo} size="1.5x" />
					<span class="sr-only">Info icon</span>
				{/if}
				{#if type === 'error'}
					<SvelteFa icon={faCircleExclamation} size="1.5x" />
					<span class="sr-only">Alert icon</span>
				{/if}
			</div>

			{#if useHtml}
				{@html message}
			{:else}
				<span class="my-auto">{message}</span>
			{/if}

			<button
				type="button"
				class="ml-auto -mx-1.5 -my-1.5 rounded-lg focus:ring-2 p-2 inline-flex h-8 w-8 {type ===
				'success'
					? 'btn-success'
					: type === 'info'
						? 'btn-info'
						: type === 'warning'
							? 'btn-warning'
							: 'btn-error'}"
				aria-label="Close"
				on:click={() => {
					document.getElementById(elemId).classList.add('hidden');
				}}
			>
				<span class="sr-only">Close</span>
				<svg
					aria-hidden="true"
					class="w-5 h-5"
					fill="currentColor"
					viewBox="0 0 20 20"
					xmlns="http://www.w3.org/2000/svg"
					><path
						fill-rule="evenodd"
						d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
						clip-rule="evenodd"
					/></svg
				>
			</button>
		</div>
		<div class="flex justify-end">
			{#each functions as f}
				<button class="btn btn-primary" on:click={f.function}>{f.label}</button>
			{/each}
		</div>
	</div>
</div>
